import { render, staticRenderFns } from "./EbookContentSection.vue?vue&type=template&id=ef20dd42&scoped=true"
import script from "./EbookContentSection.vue?vue&type=script&lang=js"
export * from "./EbookContentSection.vue?vue&type=script&lang=js"
import style0 from "./EbookContentSection.vue?vue&type=style&index=0&id=ef20dd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef20dd42",
  null
  
)

export default component.exports